import styled from 'styled-components';
import { addAlpha } from '@algoan/deep-dive/theme';

export interface SwitchProps {
  className?: string;
  /** A value to dictate whether the checkbox is checked or unchecked */
  checked: boolean;
  /** A function that is fired upon click or tap of the checkbox. This should be tied to
   * a method to mutate a state value. */
  onChange: () => void;
  dataTestId?: string;
}

export const Switch = ({ className, checked, onChange, dataTestId }: SwitchProps): JSX.Element => {
  return (
    <S.Switch className={className}>
      <S.Input type="checkbox" checked={checked} onChange={onChange} />
      <S.Slider data-testid={dataTestId} checked={checked} />
    </S.Switch>
  );
};

const S = {
  Switch: styled.label`
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
  `,
  Input: styled.input`
    display: none;
  `,
  Slider: styled.span<{ checked: boolean }>`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${(props) =>
      props.checked ? props.theme.extraColors.bluePeps : addAlpha(props.theme.extraColors.silver, 0.6)};
    box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    transition: 0.3s;

    &::before {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      left: 2px;
      bottom: 2px;
      background: #fff;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      transition: 0.3s;
      transform: translateX(${(props) => (props.checked ? 24 : 0)}px);
    }
  `,
};
